import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=7f8b736e&scoped=true"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=7f8b736e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b736e",
  null
  
)

export default component.exports